module.exports = "mutation DeleteCategory($categoryId:ID!){deleteCategory(categoryId:$categoryId){success}}"